import section5bg from "../../../assets/images/section5_bg.svg";
import radius from "../../../assets/images/section2_radius.svg";
import location from "../../../assets/images/location.svg";
import phone from "../../../assets/images/phone.svg";
import Container from "../../../components/container";
import useRipple from "use-ripple-hook";
import { useEffect, useState } from "react";
import sendEmail from "../../../functions/send_email";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

export default function Section5() {
    const [visibleCaptcha, setVisibleCaptcha] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);
    const [messageSent, setMessageSent] = useState(false);


    const [error, setError] = useState({
        name: false,
        email: false,
        message: false,
    });
    const [state, setState] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [ripple2, event2] = useRipple({
        disabled: false,
        duration: 450,
        color: "#ffffff30",
        cancelAutomatically: false,
        timingFunction: "cubic-bezier(.42,.36,.28,.88)",
    });

    async function sendMessage() {
        try {
            const error = await sendEmail({
                fromEmail: state.email,
                userName: state.name,
                message: state.message,
                to: "devsoftexinfo@devsoftex.com",
                apiKey: "246530996d9282dc26e9f4d1bc4ac7e7"
            })
           
            if (error) {
                setError((prev)=>{
                    return {...prev, email: "Error! Please enter a valid email"}
                })
                return;
            }
            setState({
                name: "",
                email: "",
                message: "",
            });
            setMessageSent(true);
            setTimeout(() => {
                setMessageSent(false);
            }, 5000);
        } catch (error) {
            alert("Email is not valid!");
        }
    }

    useEffect(() => {
        if (captchaValue && visibleCaptcha) {
            sendMessage().then(() => {
                setVisibleCaptcha(false);
                setCaptchaValue(null);
            });
        }
    }, [captchaValue]);
    return (

        <div className={`bg-[#8C4E8C] pt-[40px] flex flex-col relative h-max sm:h-[500px] ${(error.email || error.name || error.message || messageSent) && "sm:!h-[570px]"} overflow-hidden section5`}>
            <img src={section5bg} alt="section5bg" className="absolute top-[80px] left-1/2 transform -translate-x-1/2 hidden lg:block z-1" />
            <div className="flex items-center justify-center w-full"
                id="contacts"
            >
                <div className="bg-[#FFFFFF33] h-[30px] w-full rounded-r-[5px]"></div>
                <h5 className="text-[#FFFFFF] text-[24px] lg:text-[36px] leading-[30px] lg:leading-[40px] uppercase px-[35px] font-bold">Contacts</h5>
                <div className="bg-[#FFFFFF33] h-[30px] w-full rounded-l-[5px]"></div>
            </div>

            <Container className="flex justify-center z-10">
                <div className="flex flex-col items-center w-full max-w-[570px]">
                    <div className="flex flex-col sm:flex-row w-full justify-between items-start mt-[40px] sm:mt-[44px]">
                        <div className="flex flex-col items-start">
                            <div className="flex items-center">
                                <img src={location} alt="location" />
                                <span className="text-[15px] text-[#fff] font-bold leading-[24px] ml-[10px]">Devsoftex LLC</span>
                            </div>
                            <span className="text-[#fff] text-[15px] leading-[25px] font-normal">8001, Bulgaria, Burgas, </span>
                            <span className="text-[#fff] text-[15px] leading-[25px] font-normal">Odrin 15, floor 9.</span>
                        </div>
                        <div className="flex flex-col items-start mt-[40px] sm:mt-0">
                            <div className="flex items-center">
                                <img src={phone} alt="phone" />
                                <span className="text-[15px] text-[#fff] font-bold leading-[24px] ml-[10px]">Phone</span>
                            </div>
                            <span className="text-[#fff] text-[20px] lg:text-[24px] leading-[30px] font-normal mt-[13px]">+359 88 4019086</span>
                        </div>
                    </div>
                    <div className="flex flex-col sm:flex-row items-start gap-[10px] w-full mt-[34px]">
                        <div className="flex flex-col w-full">
                            <input type="text"
                                name="name"
                                placeholder="Name"
                                value={state.name}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, name: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, name: false };
                                    });
                                }}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Name")}
                                className={`z-10 outline_input ${error.name && "error"}`}
                            />
                            {error.name && <span className="text-[#FF3333] text-[14px] font-bold">Error! Please enter your name</span>}
                        </div>

                        <div className="flex flex-col w-full">
                            <input type="text"
                                name="email"
                                placeholder="Email"
                                value={state.email}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Email")}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, email: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, email: false };
                                    });
                                }}

                                className={`z-10 outline_input ${error.email && "error"}`}
                            />
                            {error.email && <span className="text-[#FF3333] text-[14px] font-bold">{error.email}</span>}
                        </div>
                    </div>
                    {visibleCaptcha ? <div className="flex h-[80px] w-full justify-center items-center mt-3">
                        <ReCAPTCHA
                            sitekey="6LfobvEqAAAAAP3vSDKFLVA7Mi46fz4SqpG-8aiI"
                            onChange={(value) => setCaptchaValue(value)}
                        />
                    </div> :
                        <div className="flex flex-col w-full">
                            <textarea name="message" id="message" value={state.message}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, message: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, message: false };
                                    });
                                }}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Message")}
                                placeholder="Message" className={`z-10 w-full !h-[169px] sm:!h-[80px] mt-[10px] outline_input decoration-none pt-[10px] ${error.message && "error"}`}
                            ></textarea>
                            {error.message && <span className="text-[#FF3333] text-[14px] font-bold">Error! Please enter your message</span>}
                        </div>
                    }
                    <div className="flex flex-col w-full mt-[10px] mb-[80px] items-center justify-center gap-3">
                        {messageSent && <div className="w-full h-[40px] bg-white border-[2px] border-[#71AD80] text-[#71AD80] text-[14px] font-bold pl-[15px] flex items-center">
                            <span className="leading-[24px]">Thank you for your message! It has been sent</span>
                        </div>}
                        {(error.email || error.name || error.message) && <div className="w-full h-[40px] bg-white border-[2px] border-[#E23D3D] text-[#E23D3D] text-[14px] font-bold pl-[15px] flex items-center">
                            <span className="leading-[24px]">One or more fields have an error</span>
                        </div>}
                        <button
                            ref={ripple2}
                            onMouseDown={event2}
                            className={`w-[170px] h-[40px] bg-[#71AD80] button transition ease-in-out duration-300 rounded-[5px] text-[#fff] text-[14px] font-bold button overflow-hidden z-10`}
                            onClick={() => {
                                const newError = {
                                    email: state.email.length === 0 ? "Error! Please enter your email" : false,
                                    message: state.message.length === 0,
                                    name: state.name.length === 0,
                                };
                                setError(newError);
                                if (newError.email || newError.message || newError.name) return;

                                setVisibleCaptcha(true);
                            }}
                        >
                            SEND MESSAGE
                        </button>
                    </div>
                </div>
            </Container>
            <img src={radius} alt="radius" className="w-[630px] h-[70px] absolute bottom-[-9px] sm:bottom-[-18px] left-1/2 transform -translate-x-1/2" />
            <span className="absolute bottom-[8px] sm:bottom-[10px] left-1/2 transform -translate-x-1/2 text-[#8C4E8C] text-[14px] leading-[14px] font-normal whitespace-nowrap">2025. Devsoftex. All rights reserved.</span>
        </div>);
}
